<template >

    <div>
        <div class="row fundo">
            <div class="menu-btn">
                <span class="fa fa-bars"></span>
            </div>

            <nav class="d-none d-md-block bg-light sidebar">
            <div class="sidebar-sticky">
                <ul class="nav" v-if="menus && menus.length" >
                <li class="nav-item pr-2 ml-1 text-center" v-for="menu of menus" v-bind:key="menu.ba06_id">
                    <div v-if="menu.ba06_sistema_id == sistema_id && menu.ba06_pai_id == null">
                    <router-link :to="menu.ba06_url"  class="borda nav-link">
                        <span data-feather="file"></span>
                        <i :class="menu.ba06_icone"></i>
                    </router-link>
                    <p class="mt-3">{{menu.ba06_nome}}</p>
                    </div>
                </li>
                </ul>
            </div>
            </nav>

        </div>
  </div>

</template>

<script>
import Obras from "../obras/Obras.vue"


export default {
  name: 'MenuPainel',
  components: {
    Obras
  },
  data () {
    return {
      menus: '',
      sistema_id: API.sistema_id
    }
  },
  mounted () {
      API.enviarRequisicao('get', '/api/controleacesso/menus')
      .then(response => (this.menus = response.data))

    $(document).ready(function () {
        $('.menu-btn').on('click', function () {
            $('.sidebar').toggleClass('active');
            $('.menu-btn').toggleClass('active');
           });
        });
   }
}

</script>

<style scoped>
    .menu-btn{
        position: absolute;
        z-index: 99;
        top: 10px;
        left: 280px;
        cursor: pointer;
        color: white;
        font-size: 23px;
        transition: all 0.3s;
    }

    .menu-btn.active{
        margin-left: -190px;
    }

    .borda {
        width: 70px;
        background-color: #88a5b0;
        border-radius: 5px;
    }

    p {
        color: #fff;
    }

    i {
        font-size: 50px;
    }

    a {
        padding: 12px 5px;
    }

    a:hover {
        background-color: #18A689;
        color: #fff;
        border: none;
    }

    ul {
        margin-top: 20px;
    }

    .router-link-exact-active {
        background-color: #18A689;
    }

    .fundo{
        height: 100%;
    }
    a:focus {
        box-shadow: 0 0 0 0;
        border: 0 none;
        outline: 0;
    }
    .sidebar {
    background-color: #161e37 !important;
    min-height: 100vh;
    width: 270px;
    transition: all 0.3s;
  }

  .sidebar.active {
      margin-left: -190px;
  }

  .sidebar.active li{
      width: 100%;
  }

  .sidebar.active li i{
      font-size: 25px;
  }

  .sidebar.active li p{
      margin-top: 5px!important;
      display: none;
  }

  .sidebar.active li a{
      width: 50px;
      margin-bottom: 8px;
  }

  .sidebar.active li>div{
      float: right;
      font-size: 9px;
  }

  ul {
    margin-top: 20px;
  }

  li .active {
    background-color: #18a689;
  }
</style>
